import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContrast = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20 10V30",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgContrast);
export default ForwardRef;
